/* react-map-gl is a very large import (https://bundlephobia.com/result?p=react-map-gl)
 * Adding this large import to the main bundle would hinder overall site performance
 * So we decided to use webpack's dynamic import to load the library that way this package is only loaded in the search page.
 * Similar reasoning applies to mapbox-gl + viewport-mercator-project
 */
export function importMapboxDependencies() {
  return Promise.all([
    import(/* webpackChunkName: "mapbox" */ 'mapbox-gl'),
    import(/* webpackChunkName: "mapbox" */ 'viewport-mercator-project'),
    import(/* webpackChunkName: "mapbox" */ 'react-map-gl'),
  ]).then(([Mapbox, ViewportMercatorProject, ReactMapGL]) => ({
    Mapbox,
    ViewportMercatorProject,
    ReactMapGL,
  }));
}

export const encodeBounds = ([[southwestLon, southwestLat], [northeastLon, northeastLat]]) =>
  `${southwestLon},${southwestLat},${northeastLon},${northeastLat}`;

export const decodeBounds = encodedBounds => {
  const [southwestLon, southwestLat, northeastLon, northeastLat] = encodedBounds.split(',').map(parseFloat);

  return [[southwestLon, southwestLat], [northeastLon, northeastLat]];
};

export const getEncodedBoundsForViewport = viewport => {
  const { height, width } = viewport;

  const bounds = [viewport.unproject([0, height]), viewport.unproject([width, 0])];
  return encodeBounds(bounds);
};
